<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Theater of God’s Glory: Calvin, Creation, and the Liturgical Arts</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="CON1t"><a id="page_vii"></a><a href="#/xhtml/foreword" id="foreword"><i>Foreword</i>, by John D. Witvliet</a></p>
<p class="CON1"><a href="#/xhtml/acknowledgments" id="ack">Acknowledgments</a></p>
<p class="CON1"><a href="#/xhtml/abbreviations" id="abbreviations">Abbreviations</a></p>
<p class="CON3"><a href="#/xhtml/introduction" id="introduction">Introduction</a></p>
<p class="CON2"><a href="#/xhtml/chapter001" id="chapter001">1.<span class="space75">Musical Instruments in Calvin</span></a></p>
<p class="CON2"><span href="#/xhtml/chapter002" id="chapter002" title="Link target outside of Sample">2.<span class="space75">The Work of the Material Creation</span></span></p>
<p class="CON2"><span href="#/xhtml/chapter003" id="chapter003" title="Link target outside of Sample">3.<span class="space75">The Work of the Material Symbols of Worship</span></span></p>
<p class="CON2"><span href="#/xhtml/chapter004" id="chapter004" title="Link target outside of Sample">4.<span class="space75">The Twin Problem of Materiality and Mediation</span></span></p>
<p class="CON2"><span href="#/xhtml/chapter005" id="chapter005" title="Link target outside of Sample">5.<span class="space75">The Double Movement of Creation in Worship</span></span></p>
<p class="CON2"><span href="#/xhtml/chapter006" id="chapter006" title="Link target outside of Sample">6.<span class="space75">Calvin’s Theology of the Physical Body</span></span></p>
<p class="CON2"><span href="#/xhtml/chapter007" id="chapter007" title="Link target outside of Sample">7.<span class="space75">A Trinitarian Theology of the Physical Body</span></span></p>
<p class="CON2"><span href="#/xhtml/chapter008" id="chapter008" title="Link target outside of Sample">8.<span class="space75">The “Simple” Worship of God</span></span></p>
<p class="CON2"><span href="#/xhtml/chapter009" id="chapter009" title="Link target outside of Sample">9.<span class="space75">The Trinitarian Space of Worship</span></span></p>
<p class="CON3"><span href="#/xhtml/chapter010" id="chapter010" title="Link target outside of Sample">Conclusion</span></p>
<p class="CON1"><span href="#/xhtml/bibliography" id="bibliography" title="Link target outside of Sample">Select Bibliography</span></p>
<p class="CON1"><span href="#/xhtml/index" id="index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?38cf44bc